import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import "@/i18n";
import App from "@/App";

// V23.15.56 — Suppression du bruit "ResizeObserver loop completed with
// undelivered notifications". Bug connu de CRA v5 + react-flow : chaque
// tick d'animation déclenche un warning bénin que l'overlay CRA transforme
// en erreur bloquante.
//
// Solution officielle : monkey-patch ResizeObserver avec un debounce 20ms.
// Le navigateur perd juste 20ms de latence sur les notifications de resize
// (invisible à l'œil), en échange plus AUCUN warning ne remonte à la boucle
// principale → overlay CRA propre + animations fluides possibles.
if (typeof window !== "undefined" && window.ResizeObserver) {
  const _ROC = window.ResizeObserver;
  window.ResizeObserver = class DebouncedResizeObserver extends _ROC {
    constructor(callback) {
      let timer = null;
      const debounced = (entries, observer) => {
        if (timer) cancelAnimationFrame(timer);
        timer = requestAnimationFrame(() => {
          try { callback(entries, observer); } catch (_e) { /* silent */ }
        });
      };
      super(debounced);
    }
  };
}
const RO_WARNING = /ResizeObserver loop (completed with undelivered notifications|limit exceeded)/;
window.addEventListener("error", (event) => {
  if (event?.message && RO_WARNING.test(event.message)) {
    event.stopImmediatePropagation();
    event.preventDefault();
  }
});
const _origConsoleError = console.error;
console.error = (...args) => {
  const first = args[0];
  const asStr = typeof first === "string" ? first : (first?.message || "");
  if (RO_WARNING.test(asStr)) return;
  _origConsoleError.apply(console, args);
};

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
